export default __webpack_public_path__ + "static/media/wethefoodie.aa9b60c2.png";